
import { navigationModeMenuStyles } from "@insite/content-library/Components/NavigationModeMenu";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

navigationModeMenuStyles.navigationModeSelect = {
    backgroundColor: "transparent",
    iconProps: {
        color: "#ffffff"
    },
    cssOverrides: {
        formInputWrapper: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        width: 118px;
                    `,
                    css`
                        width: 271px;
                    `,
                ])},
        `,
        inputSelect: css`
            border: none;
            text-transform: uppercase;
            color: #ffffff;
            option{
                color: black;
            }
        `,
    },
};
